export const removeTrailingSlash = (value: string) => {
  return value.replace(/\/+$/, '');
};
